import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { ReasonForRejectComponent } from 'src/app/components/dialog/reasons/reason-for-reject/reason-for-reject.component';
import { ApiService, DialogModalService, NotificationService, PermissionService } from 'src/app/services';

@Component({
  selector: 'app-change-state',
  templateUrl: './change-state.component.html',
  styleUrls: ['./change-state.component.css']
})
export class ChangeStateComponent implements OnInit {

  progressRef: NgProgressRef;
  productsData: any[] = [];
  moduleName: string;
  state_begin: string;
  reason: any;

  @Input() set _objectData(value: any) {

    if (value) {

      this.productsData = value.productsData;
      this.moduleName = value.module;

    }
  }

  @Output() updateEvent = new EventEmitter();

  constructor(
    public ngProgress: NgProgress,
    private notification: NotificationService,
    private api: ApiService,
    private dialogModal: DialogModalService,
    private permissionService: PermissionService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');

  }

  /**
   * Проверяем имеется ли в списке действий(actions) запрашиваемое действие(actionVal)
   * @param actionVal допускается имя действия или ID действия
   */
  check(actionName: string): boolean {

    if (this.productsData.length == 0) return false;

    for (let product of this.productsData) {

      if (!this.permissionService.check(actionName, product.state_id)) {

        return false;
      }

    }

    return true;
  }

  /**
   * 
   * @param status 
   */
  changeState(status: string, reason: any) {

    this.progressRef.start();

    let ids: any[] = [];
    let methodName: string;

    for (let product of this.productsData) {
      ids.push(product.id);
    }

    let data = {
      "object": this.moduleName,
      "id": ids,
      "state": status,
      "reason": reason
    }

    if (status == 'APPROVED') {
      methodName = 'product/stateApproved'
    } else if (status == 'REJECTED') {
      methodName = 'product/stateRejected'
    } else if (status == 'PUBLISHED') {
      methodName = 'product/statePublished'
    } else if (status == 'MODERATION') {
      methodName = 'product/stateModeration'
    }

    this.api.post(methodName, data, "private").subscribe(response => {

      if (response != null) {
        this.notification.show('success', 'Данные успешно сохранены!');
        this.updateEvent.emit(true);
      }
      this.progressRef.complete();
    });
  }

  /**
   * 
   * @param status 
   */
  openDialogIndicateReasonForReject(status: string): void {

    this.dialogModal.open(null, ReasonForRejectComponent).then(
      (result) => {

        if (result) {

          this.changeState(status, result);

        }
      },
      () => { console.log('Rejected!'); }
    );
  }
}
